import PropTypes from 'prop-types';
import {
  KitIcon,
  NonReturnableIcon,
  RemanufacturedIcon,
  ReplacementPartIcon
} from 'cat-ecommerce-alloy';

export const ProductIcons = ({
  isReman,
  isNonReturnable,
  isKit,
  isReplacedPart
}) => {
  return (
    <div className="d-flex flex-row mt-2">
      {isNonReturnable && (
        <NonReturnableIcon
          className="u-fill-icon--DarkGray"
          width={16}
          height={16}
        />
      )}
      {isReplacedPart && (
        <ReplacementPartIcon
          className="u-fill-icon--DarkGray"
          width={16}
          height={16}
        />
      )}
      {isReman && (
        <RemanufacturedIcon
          className="u-fill-icon--MediumGray"
          width={16}
          height={16}
        />
      )}

      {isKit && (
        <KitIcon className="u-fill-icon--DarkGray" width={16} height={16} />
      )}
    </div>
  );
};
export default ProductIcons;

ProductIcons.propTypes = {
  isReman: PropTypes.bool,
  isNonReturnable: PropTypes.bool,
  isKit: PropTypes.bool,
  isReplacedPart: PropTypes.bool
};
